<div id="success-snackbar"></div>
<div id="error-snackbar"><i class="fa fa-times-circle" aria-hidden="true"></i>
    &nbsp;&nbsp;<span id="error-msg-disp"></span>&nbsp;&nbsp;
</div>
<app-header></app-header>
<router-outlet></router-outlet>
<app-footer></app-footer>
<app-complete-profile-modal></app-complete-profile-modal>
